import {inject, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {workflowsDefinitions} from "./definition";
import {WorkflowsStoreFacadeService, WorkflowsStoreModule} from "@well/iriro-frontend-libs/workflows/store";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    WorkflowsStoreModule
  ]
})
export class WellWorkflowsModule {

  workflowsStoreFacadeService = inject(WorkflowsStoreFacadeService);

  constructor() {
    this.workflowsStoreFacadeService.addFrontEndDefinitions(workflowsDefinitions)
  }

}
